import Swiper, { Autoplay, FreeMode, Navigation,EffectFade,Virtual, Pagination, Scrollbar } from 'swiper'
import Vue from 'vue'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

import * as THREE from 'three'
import Globe from 'globe.gl'
import 'lazysizes'
import countries from '../json/custom.geo.json'


let itemArr = []
let imgArr = []

window.addEventListener('DOMContentLoaded', () => {
    itemArr = [...document.querySelectorAll('.js-fadeup')]
    imgArr = [...document.querySelectorAll('.e-equalColumn--img img')]
})

let MAP
if (document.getElementById('earth') && document.getElementById('mapJson')) {
    MAP = JSON.parse(document.getElementById('mapJson').textContent)
}

let LINE
if (document.getElementById('earth') && document.getElementById('lineJson')) {
    LINE = JSON.parse(document.getElementById('lineJson').textContent)
}


gsap.registerPlugin(ScrollTrigger)
gsap.defaults({ ease: 'sine.out' })

// 禁用滾動

window.addEventListener('beforeunload', function() {
    window.scrollTo(0, 0);
});

document.body.style.overflow = 'hidden';
  

window.addEventListener('load', function() {
    document.body.style.overflow = 'auto';

    // 0.5秒後顯示header並滾動到video-wrap
    setTimeout(function() {
        var header = document.querySelector("header");
        if (header) {
            header.classList.add("visible-header");
        }
    
        var videoWrap = document.querySelector(".video-wrap");
        if (videoWrap) {
            var headerHeight = header.offsetHeight;
            var elementPosition = videoWrap.getBoundingClientRect().top;
            var currentPosition = window.pageYOffset;
            var targetPosition = elementPosition + currentPosition - headerHeight;
    
            var startTime = null;
            var duration = 1000; 
    
            function animateScroll(timestamp) {
                if (!startTime) startTime = timestamp;
                var progress = timestamp - startTime;
                var percent = Math.min(progress / duration, 1);
                var scrollPosition = currentPosition + (targetPosition - currentPosition) * percent;
    
                window.scrollTo(0, scrollPosition);
    
                if (progress < duration) {
                    window.requestAnimationFrame(animateScroll);
                } else {
                    // 動畫結束後，0.5秒後添加hidden class到loading元素
                    setTimeout(function() {
                        var loadHeader = document.getElementById('load-header');
                        if (loadHeader) {
                            loadHeader.style.position = 'static'; // 或者設定為 'static'
                        }
                        var loadingElement = document.querySelector(".loadinging");
                        if (loadingElement) {
                            loadingElement.classList.add("hidden");
                            window.scrollTo(0, 0);
                        }
                    }, 500); 
                }
            }
    
            window.requestAnimationFrame(animateScroll);
        }
    }, 500); 
    
});




new Vue({
    el: '#video',
    name: 'video',
    delimiters: ['${', '}'],
    store: window.store,
    data() {
        return {
            isGlobeRotate: true,
            isCitySelected: false,
            cityObj: {},
            world: null,
            locationTypeIdx: null,
            countryIdx: null,
            cityIdx: null,
            cityName: null
        }
    },
    methods: {
        handleScrollTrigger() {
            gsap.set('.l-video--btn', { opacity: 0 })
            gsap.to('.l-video--btn', { opacity: 1, y: 0,delay: 1})
            gsap.set('.l-highlights--title span', { opacity: 0, y: '100%' })
            gsap.set('.l-highlights--desc', { opacity: 0, y: '20%' })
            gsap.to('.l-highlights--title span', {
                scrollTrigger: {
                    trigger: '.l-highlights',
                    start: '-80% 60px',
                    end: '-40% 60px',
                    scrub: 0.7,
                    once: true
                },
                opacity: 1,
                y: 0,
                stagger: 0.1
            })
            gsap.to('.l-highlights--desc', {
                scrollTrigger: {
                    trigger: '.l-highlights',
                    start: '-50% 100%',
                    end: '0 0',
                    scrub: 0.7,
                    once: true
                },
                opacity: 1,
                y: 0,
            })
            gsap.set('.l-map--tag', { opacity: 0 })
            gsap.set('.l-map--title', { opacity: 0, y: '20%' })
            gsap.set('.l-map--desc', { opacity: 0, y: '20%' })
            gsap.to('.l-map--tag', {
                scrollTrigger: {
                    trigger: '.l-map',
                    start: '-120% 100%',
                    end: '-80% 0',
                    scrub: 0.7,
                    once: true
                },
                opacity: 1,
                y: 0,
            })
            gsap.to('.l-map--title', {
                scrollTrigger: {
                    trigger: '.l-map',
                    start: '-120% 100%',
                    end: '-80% 0',
                    scrub: 0.7,
                    once: true
                },
                opacity: 1,
                y: 0,
            })
            gsap.to('.l-map--desc', {
                scrollTrigger: {
                    trigger: '.l-map',
                    start: '-120% 100%',
                    end: '-80% 0',
                    scrub: 0.7,
                    once: true
                },
                opacity: 1,
                y: 0,
            })
            gsap.set('.l-news--title span', { opacity: 0, y: '20%' })
            gsap.to('.l-news--title span', { 
                scrollTrigger: {
                    trigger: '.l-news',
                    start: '-120% 100%',
                    end: '-80% 0',
                    scrub: 0.7,
                    once: true
                },
                opacity: 1,
                y: 0,
                stagger: 0.1
            },)
            gsap.set('.l-news--slider', { opacity: 0 })
            gsap.to('.l-news--slider', { 
                scrollTrigger: {
                    trigger: '.l-news',
                    start: '-120% 100%',
                    end: '-80% 0',
                    scrub: 0.7,
                    once: true
                },
                opacity: 1,
                y: 0,
            },)
            
            gsap.set('.l-reports--title span', { opacity: 0, y: '20%' })
            gsap.to('.l-reports--title span', { 
                scrollTrigger: {
                    trigger: '.l-reports',
                    start: '-130% 100%',
                    end: '-110% 0',
                    scrub: 0.7,
                    once: true
                },
                opacity: 1,
                y: 0,
                stagger: 0.1
            },)
            gsap.set('.l-reports--item', { opacity: 0, y: '20%' })
            gsap.to('.l-reports--list .l-reports--item', { 
                scrollTrigger: {
                    trigger: '.l-reports',
                    start: '-130% 100%',
                    end: '-110% 0',
                    scrub: 0.7,
                    once: true
                },
                opacity: 1,
                y: 0,
                stagger: 0.1
            },)
        },
        // tweenNumber() {
        //     const numbers = [...document.querySelectorAll('.l-highlights--slide__value'), ...[]]

        //     numbers.forEach(n => {
        //         const isNumber = Number(n.textContent) || n.textContent === '0'
        //         if (isNumber) {
        //             const value = Number(n.textContent) ? n.textContent : '0'
        //             const isFloat = value.indexOf('.') !== -1
        //             const obj = {
        //                 val: 0,
        //             }
        //             const tl = gsap.timeline({
        //                 scrollTrigger: {
        //                     trigger: n,
        //                 },
        //             })
        //             tl.from(n, {
        //                 opacity: 0,
        //                 duration: 0.2,
        //             })
        //             tl.to(obj, {
        //                 duration: 1,
        //                 val: value,
        //                 ease: 'linear',
        //                 onUpdate() {
        //                     if (isFloat) {
        //                         n.innerHTML = obj.val
        //                             .toFixed(value.slice(value.indexOf('.') + 1).length)
        //                             .toString()
        //                             .replace(/(\d{1,3})(?=(\d{3})+\.)/g, '$1,')
        //                     } else {
        //                         n.innerHTML = parseInt(obj.val)
        //                             .toString()
        //                             .replace(/(\d{1,3})(?=(\d{3})+$)/g, '$1,')
        //                     }
        //                 },
        //             })
        //         }
        //     })
        // },
        handleMouseOver() {
            const elements = document.querySelectorAll('.aaa.active');
            elements.forEach(element => {
                element.classList.remove('active');
            });
        },
        initGlobe() {
            this.world
                .hexPolygonsData(countries.features)
                .hexPolygonColor(() => '#6F82A4')
                .hexPolygonResolution(4)
                .hexPolygonMargin(0.6)
                .showAtmosphere(true)
                .atmosphereColor('#FFF2FF')
                .atmosphereAltitude(0.05)
                .onGlobeReady(() => setTimeout(() => {
                    this.world.camera().aspect = window.innerWidth / window.innerHeight
                    this.world.camera().updateProjectionMatrix()

                    this.world.camera().position.set(0, 0, 0)
                    this.setGlobeRotation(121.5, 25); 
                    // this.world.camera().rotateY(-Math.PI * (5 / 9))
                    // this.world.camera().rotateZ(-Math.PI / 6)

                    this.world.controls().enableDamping = true
                    this.world.controls().dynamicDampingFactor = 0.01
                    this.world.controls().enablePan = false
                    this.world.controls().rotateSpeed = 0.8
                    this.world.controls().minDistance = 200
                    this.world.controls().maxDistance = 400
                    this.world.controls().enableZoom = false
                    this.world.controls().autoRotate = this.isGlobeRotate
                    this.world.controls().autoRotateSpeed = 0.6
                    this.world.controls().minPolarAngle = Math.PI / 3.5
                    this.world.controls().maxPolarAngle = Math.PI - Math.PI / 3

                    const globeMaterial = this.world.globeMaterial()
                    globeMaterial.color = new THREE.Color(0x19427B)
                    globeMaterial.opacity = 0.9
                    globeMaterial.emissive = new THREE.Color(0x19427B)
                    globeMaterial.emissiveIntensity = 0.1
                    globeMaterial.shininess = 0

                    const OPACITY = 0.6
                    this.world.arcsData(LINE)
                        .arcColor(() => [`rgba(224, 0, 77, ${OPACITY})`, `rgba(250, 193, 214, ${OPACITY})`])
                        .arcStroke(0.2)
                        .arcDashLength(0.9)
                        .arcDashGap(4)
                        .arcDashAnimateTime(1000)
                        .arcsTransitionDuration(1000)
                        .arcDashInitialGap((e) => e.order * 1)
                        .labelsData(MAP)
                        .labelColor(() => '#efefef')
                        .labelDotRadius(0.2)
                        .labelSize(0.85)
                        .labelDotOrientation(() => 'right')
                        .labelText('code')
                        .labelResolution(6)
                        .labelAltitude(0.02)
                        .onLabelClick((e) => {
                            this.cityObj = {
                                lat: e.lat,
                                lng: e.lng,
                                country: e.country,
                                business: e.business,
                                premium_economy: e.premium_economy,
                                economy: e.economy,
                                cargo: e.cargo
                            }
                            console.log(e);
                            this.isCitySelected = true
                            console.log(this.isCitySelected);
                        })

                }, 500))
                
                .onGlobeClick(() => {
                    this.isGlobeRotate = !this.isGlobeRotate
                    this.world.controls().autoRotate = this.isGlobeRotate
                })

            window.addEventListener('resize', (event) => {
                this.world.width([event.target.innerWidth])
                this.world.height([event.target.innerHeight])
            })
            
            
        },
        setGlobeRotation(longitude, latitude) {
            const phi = (90 - latitude) * (Math.PI / 180);
            const theta = (longitude + 180) * (Math.PI / 180);
            const x = 240 * Math.sin(phi) * Math.cos(theta);
            const y = 240 * Math.cos(phi);
            const z = 240 * Math.sin(phi) * Math.sin(theta);
    
            this.world.camera().position.set(x, y, z);
            this.world.camera().lookAt(0, 0, 0); 
          }
    },
    mounted() {
        this.world = Globe({
            waitForGlobeReady: true,
            animateIn: true,
        })(document.getElementById('globe'))
        .backgroundColor('#23569D')
        this.initGlobe()
        
        this.$nextTick(() => {
            window.onload = () => {
                this.handleScrollTrigger();
            };
            // this.tweenNumber()
            
            setTimeout(() => {
            }, 2000)
        })
        const bbbElements = document.querySelectorAll('.bbb');
        bbbElements.forEach(element => {
            element.addEventListener('mouseover', this.handleMouseOver);
        });

        
        // document.addEventListener("DOMContentLoaded", function() {
        //     setTimeout(function() {
        //         var header = document.querySelector("header");
        //         if (header) {
        //             header.classList.add("visible-header");
        //         }
        
        //         var videoWrap = document.querySelector(".video-wrap");
        //         if (videoWrap) {
        //             var headerHeight = header.offsetHeight;
        //             var elementPosition = videoWrap.getBoundingClientRect().top;
        //             var currentPosition = window.pageYOffset;
        //             var targetPosition = elementPosition + currentPosition - headerHeight;
        
        //             window.scrollTo({
        //                 top: targetPosition,
        //                 behavior: 'smooth'
        //             });
        //         }
        //     }, 3000);
        // });
        
        
        
        
    }
})



var scrollButton = document.getElementById('scrollButton');
var targetElement = document.getElementById('index');

scrollButton.addEventListener('click', function() {
  var offsetTop = targetElement.offsetTop;
  window.scrollTo({
    top: offsetTop,
    behavior: 'smooth' 
  });
});


var outerSwiper = new Swiper('.l-outhighlights--slider', {
    modules: [EffectFade,Pagination],
    slidesPerView: 1,
    allowTouchMove: false,
    effect: 'fade',
    fadeEffect: {
        crossFade: true 
    },
    pagination: {
        el: '.swiper-pagination',
        clickable: true,
        renderBullet: function (index, className) {
          const customNames = ['永續亮點', '公司治理', '環境價值', '社會價值'];
          return '<span class="' + className + '">' + customNames[index] + '</span>';
        }
      },
    on: {
        slideChange: function () {
          var currentSlideIndex = this.activeIndex;
            gsap.set('.l-highlights--title span', { opacity: 0, y: '100%' })
            gsap.set('.l-highlights--desc', { opacity: 0, y: '20%' })
            gsap.set('.l-highlights--img img', { opacity: 0})

          
            gsap.to('.l-highlights--img img', { 
                    scrollTrigger: {
                        trigger: '.l-highlights',
                        start: '0 100%',
                        end: '0 0',
                        scrub: 0.7,
                        once: true
                    },
                    opacity: 1,
            },)
            gsap.to('.l-highlights--title span', { 
                    scrollTrigger: {
                        trigger: '.l-highlights',
                        start: '-50% 60px',
                        end: '-40% 60px',
                        scrub: 0.7,
                        once: true
                    },
                    opacity: 1,
                    y: 0,
                    stagger: 0.1
            })
            gsap.to('.l-highlights--desc', {
                scrollTrigger: {
                    trigger: '.l-highlights',
                    start: '0 100%',
                    end: '0 0',
                    scrub: 0.7,
                    once: true
                },
                opacity: 1,
                y: 0,
            })
        }
      }
  });
  
  var innerSwiperContainers = document.querySelectorAll('.l-highlights--slider');
  
  innerSwiperContainers.forEach(function (container) {
    var innerSwiper = new Swiper(container, {
        modules: [Autoplay, FreeMode, Virtual,Scrollbar],
        slidesPerView: 1.5,
        spaceBetween: 20,
        scrollbar: {
            el: '.swiper-scrollbar',
            draggable: true, 
        },
        breakpoints: {
            768: {
                slidesPerView: 1.5,
            },
            992:{
                direction:'vertical',
                spaceBetween: 50,
            },
            1200: {
                direction:'vertical',
                slidesPerView: 2.5,
            },
        },
    });
  });


  document.addEventListener('DOMContentLoaded', function() {
    var swiperContainer = document.getElementById('mySwiper');
  
    swiperContainer.addEventListener('mouseenter', function() {
      swiperContainer.classList.add('custom-cursor');
    });
  
    swiperContainer.addEventListener('mouseleave', function() {
      swiperContainer.classList.remove('custom-cursor');
    });
  });

  document.addEventListener('DOMContentLoaded', function() {
    var swiperContainer = document.getElementById('mySwiper2');
  
    swiperContainer.addEventListener('mouseenter', function() {
      swiperContainer.classList.add('custom-cursor');
    });
  
    swiperContainer.addEventListener('mouseleave', function() {
      swiperContainer.classList.remove('custom-cursor');
    });
  });

  document.addEventListener('DOMContentLoaded', function() {
    var swiperContainer = document.getElementById('mySwiper3');
  
    swiperContainer.addEventListener('mouseenter', function() {
      swiperContainer.classList.add('custom-cursor');
    });
  
    swiperContainer.addEventListener('mouseleave', function() {
      swiperContainer.classList.remove('custom-cursor');
    });
  });

  document.addEventListener('DOMContentLoaded', function() {
    var swiperContainer = document.getElementById('mySwiper4');
  
    swiperContainer.addEventListener('mouseenter', function() {
      swiperContainer.classList.add('custom-cursor');
    });
  
    swiperContainer.addEventListener('mouseleave', function() {
      swiperContainer.classList.remove('custom-cursor');
    });
  });

const news = new Swiper('.l-news--slider', {
    modules: [Autoplay, FreeMode,Navigation],
    slidesPerView: 1.2,
    spaceBetween: 20,
    autoHeight: true,
    // autoplay: {
    //     delay: 1500,
    //     disableOnInteraction: false,
    //     pauseOnMouseEnter: true,
    // },
    navigation: {
        prevEl: '.l-news__prev',
        nextEl: '.l-news__next'
    },
    breakpoints: {
        768: {
            slidesPerView: 2.5,
            spaceBetween: 30
        },
        1200: {
            slidesPerView: 3,
            spaceBetween: 30
            // centeredSlides: true,
        },
    },
})
news.autoplay.stop()

const social = new Swiper('.l-social--slider', {
    modules: [Navigation],
    slidesPerView: 1,
    spaceBetween: 20,
    navigation: {
        prevEl: '.l-social__prev',
        nextEl: '.l-social__next'
    },
    breakpoints: {
        768: {
            slidesPerView: 3,
            spaceBetween: 30
        },
        1024: {
            slidesPerView: 4,
            spaceBetween: 0
        },
    },
})



